import React from "react";
import Final from './img/finaldatela.png'


function FinalComponent() {

    return(
        <>

        <div className="bg-[linear-gradient(to_right,rgba(106,13,173,0.6),rgba(255,102,178,0.6))] pt-[2%] pb-[1%] w-full bottom-0 flex justify-center">
            <img src={Final}  className="min-h-auto max-w-[80%] mx-auto" alt=""></img>
        </div>
        
        </>
    );

}

export default FinalComponent;